import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import CustomSlaIndex from './CustomSlaIndex.vue';
import CustomSlaReport from './CustomSlaReport.vue';

const meta = {
  permissions: ['administrator'],
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/custom-sla'),
      component: SettingsWrapper,
      props: {},
      children: [
        {
          path: '',
          name: 'custom_sla_wrapper',
          meta,
          redirect: to => {
            return { name: 'custom_sla_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'custom_sla_list',
          meta,
          component: CustomSlaIndex,
        },
        {
          path: 'report',
          name: 'custom_sla_report',
          meta,
          component: CustomSlaReport,
        },
      ],
    },
  ],
};
